import Axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { Redirect } from "react-router";
import Checkbox from "src/components/common/checkbox";
import MemberCodeEditModal from "src/components/css/MemberCode/MemberCodeEditModal";
import MemberCodeGroupDisplay from "src/components/css/MemberCode/MemberCodeGroupDisplay";
import AxiosConfig from "src/utilities/AxiosConfig";
import logger from '../../../../utilities/logging';
import "./MemberCodeMaintenance.css"
interface MemberCode {
    MemberCode: string
    MemberID: number
    UtilityID: number
    UtilityName: string
    CallCenterID: number
    CallCenterName: string
    ProfitCenterID: number
    ProfitCenter: string
}
interface Utility {
    UtilityName: string,
    UtilityID: number
}
interface ProfitCenter {
    ProfitCenter: string,
    ProfitCenterID: number
}
interface CallCenter {
    CallCenterName: string,
    CallCenterID: number
}
interface MemberCodeObj {
    MemberCode: string
    MemberID: number
    Utility: Utility[]
    CallCenter: CallCenter[]
    ProfitCenter: ProfitCenter[]
}
function MemberCodeMaintenance() {
    const [includesDeactivated, setIncludesDeactivated] = useState(false)
    const [searchTerm, setSearchTerm] = useState("")
    const [memberCodes, setMemberCodes] = useState<MemberCodeObj[]>([])
    const [sortField, setSortField] = useState<{ field: keyof MemberCodeObj, order: boolean }>({ field: "MemberCode", order: true });
    const [openModal, setOpenModal] = useState(false);
    const [modalData, setModalData] = useState<MemberCodeObj>({} as MemberCodeObj)
    const [memberList, setMemberList] = useState<string[]>([])
    const [isNew, setIsNew] = useState<boolean>(false)
    const [isError, setIsError] = useState(false)
    const getMemberCodes = () => {
        Axios.get(process.env.REACT_APP_API_URL + `/api/css/MemberCodes/${includesDeactivated}`, AxiosConfig.configValue("min"))
            .then((res) => {
                if (res.data.error) {
                    throw Error(res.data.error.message)
                }
                let data = res.data as MemberCode[]
                let codes = new Set(data.map((x) => x.MemberCode))
                let obj: MemberCodeObj[] = []
                codes.forEach((x) => {
                    let set = data.filter((y: MemberCode) => y.MemberCode === x)
                    let utility: Utility[] = []
                    let ProfitCenter: ProfitCenter[] = []
                    let CallCenter: CallCenter[] = []
                    set.forEach((z: MemberCode) => {
                        if (!utility.find((w) => z.UtilityName === w.UtilityName)) utility.push({ UtilityName: z.UtilityName, UtilityID: z.UtilityID })
                        if (!ProfitCenter.find((w) => z.ProfitCenter === w.ProfitCenter)) ProfitCenter.push({ ProfitCenter: z.ProfitCenter, ProfitCenterID: z.ProfitCenterID })
                        if (!CallCenter.find((w) => z.CallCenterName === w.CallCenterName)) CallCenter.push({ CallCenterName: z.CallCenterName, CallCenterID: z.CallCenterID })
                    })
                    obj.push({
                        MemberCode: x,
                        MemberID: data.find((a) => a.MemberCode === x)?.MemberID ?? -99,
                        Utility: utility.sort((a, b) => a.UtilityName > b.UtilityName ? 1 : -1),
                        ProfitCenter: ProfitCenter.sort((a, b) => a.ProfitCenter > b.ProfitCenter ? 1 : -1),
                        CallCenter: CallCenter.sort((a, b) => a.CallCenterName > b.CallCenterName ? 1 : -1)
                    })
                })
                setMemberCodes(obj.sort((a, b) => a.MemberCode > b.MemberCode ? 1 : -1))
            })
            .catch(error => {
                alert(`There was an error getting Member Codes(${error}). Redirecting Home...`);
                //console.log(error);
                logger.Error({
                    EventMessage: `ContractMaintenance -> GetContractCustomers -> Error : ${JSON.stringify(error)}`,
                    EventCategory: "httprequest"
                });
                AxiosConfig.handleError(error);
                setIsError(true)
            })
    }

    const sortByColumn = (key: keyof MemberCodeObj, order: boolean) => {
        let copyData = memberCodes
        copyData.sort((a, b) => {
            //r-18-lint-cn
            //eslint-disable-next-line
            if (key === "Utility" ? a[key][0]?.UtilityName < b[key][0]?.UtilityName === order : a[key] < b[key] === order) {
                return -1;
            }
            //r-18-lint-cn
            //eslint-disable-next-line
            if (key === "Utility" ? a[key][0]?.UtilityName > b[key][0]?.UtilityName === order : a[key] > b[key] === order) {
                return 1;
            }
            return 0;
        })
        return copyData
    }
    const searchData = (obj: MemberCodeObj[]) => {
        let copyData = obj
        copyData = copyData.filter((x) =>
            x.MemberCode.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
            x.MemberID.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
            x.CallCenter.map((y) => { return `${y.CallCenterName} (${y.CallCenterID}); ` }).toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
            x.ProfitCenter.map((y) => { return `${y.ProfitCenter} (${y.ProfitCenterID}); ` }).toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
            x.Utility.map((y) => { return `${y.UtilityName} (${y.UtilityID}); ` }).toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
        return copyData
    }
    const onSubmit = () => {
        getMemberCodes()
        setOpenModal(false)
        setIsNew(false)
    }
    useEffect(() => {
        getMemberCodes()
        //r-18-lint-cn
        //eslint-disable-next-line
    }, [])
    useEffect(() => {
        getMemberCodes()
        //r-18-lint-cn
        //eslint-disable-next-line
    }, [includesDeactivated])
    useEffect(() => {
        setMemberCodes(memberCodes)
        //r-18-lint-cn
        //eslint-disable-next-line
    }, [memberCodes])
    useEffect(() => {
        setMemberList(memberCodes.map((x) => x.MemberCode === modalData.MemberCode ? '' : x.MemberCode))
        //r-18-lint-cn
        //eslint-disable-next-line
    }, [modalData])
    return (
        <div className="MemberCodeMaintenance main-content col-sm">
            <h3>Member Code Maintenance</h3>
            <div className="memberCodeHeader">
                <Button
                    variant="secondary"
                    className="button"
                    onClick={() => (
                        //r-18-lint-cn
                        //eslint-disable-next-line
                        setOpenModal(true),
                        setModalData({
                            MemberCode: "",
                            MemberID: -99,
                            Utility: [] as Utility[],
                            CallCenter: [] as CallCenter[],
                            ProfitCenter: [] as ProfitCenter[]
                        }),
                        setIsNew(true)
                    )
                    }>
                    Add New Member Code</Button>
                <div className="ckeckDeactivate">
                    <Checkbox isChecked={includesDeactivated} onChange={() => setIncludesDeactivated(!includesDeactivated)} label="Include deactivated" className="check" />
                </div>
                <div className="searchBox">
                    <div className="searchIcon">
                        <span className="material-icons">search</span>
                    </div>
                    <input type="text" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value.toUpperCase())} className="search" placeholder="search" />
                </div>
            </div>
            <div className="memberCodeTable">
                <Table>
                    <thead className="memberCodeHead">
                        <tr>
                            <th
                                onClick={() => (sortField.field !== "MemberCode" ? (setSortField({ field: "MemberCode", order: true })) : setSortField({ ...sortField, order: !sortField.order }))}
                            >
                                Member Code<span className="material-icons">{sortField.field === "MemberCode" ? sortField.order ? `arrow_drop_down` : `arrow_drop_up` : null}</span>
                            </th>
                            <th
                                onClick={() => (sortField.field !== "Utility" ? (setSortField({ field: "Utility", order: true })) : setSortField({ ...sortField, order: !sortField.order }))}
                            >
                                Utility<span className="material-icons">{sortField.field === "Utility" ? sortField.order ? `arrow_drop_down` : `arrow_drop_up` : null}</span>
                            </th>
                            <th>Call Center</th>
                            <th>Profit Center</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            searchData(sortByColumn(sortField.field, sortField.order)).map((x, index) => (
                                //r-18-lint-cn
                                //eslint-disable-next-line
                                <tr key={index} onClick={() => (setOpenModal(true), setModalData(x))}>
                                    <td>
                                        {x.MemberCode}
                                    </td>
                                    <MemberCodeGroupDisplay utility={x.Utility} />
                                    <MemberCodeGroupDisplay call={x.CallCenter} />
                                    <MemberCodeGroupDisplay profit={x.ProfitCenter} />
                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
            </div>
            <Modal show={openModal} size="lg" onHide={() => setOpenModal(false)}>
                <Modal.Body>
                    <MemberCodeEditModal
                        data={modalData}
                        onSubmit={() => onSubmit()}
                        memberCodeList={memberList}
                        isNew={isNew}
                    />
                </Modal.Body>
            </Modal>
            {
                isError ?
                    <Redirect to="/" /> : null
            }
        </div>
    )
}

export default MemberCodeMaintenance